import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { Highlight } from 'react-instantsearch';
import SearchTag from '../../Atoms/SearchTag';

import './style.scss';

const SearchAutosuggestResult = (props) => {
  const { hit } = props;

  const type = hit.type[0];
  const combinedTypes = hit.combined_types?.[0];
  const classNames = c('AutosuggestResult__Hit');
  const { t, i18n } = useTranslation();
  const tagText = i18n.exists(`tags.${type.toLowerCase()}`)
    ? t(`tags.${type.toLowerCase()}`)
    : type;

  return (
    <div className={classNames}>
      <div className="AutosuggestResult__Hit__content">
        {hit.type && (
          <SearchTag
            className=""
            text={combinedTypes ?? tagText}
            type={type}
          />
        )}
        <Highlight className="asH4 m-0" attribute="title" hit={hit} />
      </div>
    </div>
  );
};

export default SearchAutosuggestResult;
